<template>
  <v-menu v-model="menu" offset-y :close-on-content-click="false">
    <template #activator="{ on: onMenu }">
      <v-tooltip bottom>
        <template #activator="{ on: onTooltip }">
          <v-icon v-on="{ ...onMenu, ...onTooltip }" v-text="'mdi-filter'" />
        </template>
        <span>Показать сохраненные фильтры</span>
      </v-tooltip>
    </template>

    <v-card>
      <div class="font-18 px-3 py-3">Пользовательские фильтры</div>
      <v-divider />
      <v-card-text class="pa-0">
        <v-list class="filter-list" dense>
          <v-item-group v-model="localFavoriteId">
            <v-list-item-group :value="filterId" color="primary">
              <v-list-item
                v-for="{ name, id, description } in filters"
                :key="id"
                :value="id"
                color="primary"
                class="filter-list-item"
                @click="selectUserFilter(id)"
              >
                <v-list-item-title class="filter-list-item__title">
                  <span class="mr-1">
                    {{ name }}
                  </span>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="grey darken-1"
                        style="cursor: pointer;"
                        small
                        v-on="on"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    {{ description }}
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-avatar class="filter-list-item__avatar">
                  <v-item #default="{ active, toggle }" :value="id">
                    <v-btn
                      x-small
                      icon
                      :color="active ? 'primary' : 'gray'"
                      @click.stop="toggle"
                    >
                      <v-icon small v-text="'mdi-star'" />
                    </v-btn>
                  </v-item>
                </v-list-item-avatar>
                <v-list-item-avatar class="filter-list-item__avatar">
                  <v-btn
                    x-small
                    icon
                    color="primary"
                    @click.stop="deleteUserFilter(id, name)"
                  >
                    <v-icon small v-text="'mdi-close'" />
                  </v-btn>
                </v-list-item-avatar>
              </v-list-item>
            </v-list-item-group>
          </v-item-group>
          <v-list-item v-if="!filters.length" class="filter-list-item">
            <v-list-item-title>
              Сохраненныех фильтров не найдено
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import DialogMixin from "@/mixins/DialogMixin";
export default {
  mixins: [DialogMixin],
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    /**
     * ID Выбранного фильтра
     */
    filterId: {
      type: [Number, String],
      default: null
    },
    favoriteId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    localFavoriteId: {
      get() {
        return this.favoriteId;
      },
      set(v) {
        this.$emit("update:favorite-id", v);
      }
    }
  },
  methods: {
    selectUserFilter(id) {
      this.menu = false;
      this.$emit("update:filter-id", id);
      this.$emit("select-user-filter", id);
    },
    async deleteUserFilter(id, name) {
      const confirm = await this.confirm(
        `Подтвердите удаление записи ${name}`,
        "Удаление записи",
        {
          width: 400
        }
      );
      if (!confirm) return;
      this.$emit("delete-user-filter", id);
    }
  }
};
</script>

<style lang="scss">
.filter-list {
  padding: 0;
}
.filter-list-item {
  min-width: 350px;
  height: 45px;
  padding-right: 10px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.filter-list-item:last-child {
  border-bottom: none;
}
.filter-list-item__title {
  vertical-align: middle;
}
.filter-list-item__avatar {
  margin: 0px 0px !important;
  width: 22px !important;
  min-width: 22px !important ;
}
</style>
